<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200&display=swap");

.container {
  min-height: 90vh;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  /* background-color: #eee; */
}
.container .card {
  /* height: 500px; */
  position: relative;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  font-family: "Poppins", sans-serif;
  border-radius: 20px;
}
.container .card .formulaire {
  height: 100%;
}
.container .card .left-side {
  background-color: #304767;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 20px 30px;
  box-sizing: border-box;
}
/*left-side-start*/
.steps-content {
  margin-top: 30px;
  color: #fff;
}
.steps-content p {
  font-size: 12px;
  margin-top: 15px;
}
.progress_bar {
  list-style: none;
  font-size: 13px;
  font-weight: 700;
  counter-reset: container 0;
}
.progress_bar li {
  /* display:flex; */
  list-style: none;
  counter-increment: container 1;
  position: relative;
  margin-right: 133px;
  margin-top: 20px;
}
.progress_bar li::before {
  content: counter(container);
  position: absolute;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  border: 1px solid #eef1f7;
  text-align: center;
  line-height: 26px;
  z-index: 10;
  background-color: #fff;
}

.progress_bar li::after {
  content: "";
  position: absolute;
  height: 2px;
  width: 140px;
  background-color: #f5f7fa;
  top: 12px;
  right: -10px;
}

.progress_bar li.active::after {
  background-color: #f6bc2d !important;
}

.progress_bar li:first-child:after {
  display: none;
}

.progress_bar li.active::before {
  background-color: #f6bc2d;
  border: none;
  color: #fff;
}
.progress_bar li.active {
  color: #fff;
}
.d-none {
  display: none;
}

/*left-side-end*/
.container .card .right-side {
  height: 100%;
  border-radius: 20px;
}
/*right-side-start*/
.main {
  display: none;
  opacity: 0;
  transition: 2s;
}
.active {
  display: block;
  opacity: 1;
  transition: 2s;
}
.main small {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2px;
  height: 30px;
  width: 30px;
  background-color: #ccc;
  border-radius: 50%;
  color: yellow;
  font-size: 19px;
}
.text {
  margin-top: 20px;
}
.congrats {
  text-align: center;
}
.text p {
  margin-top: 10px;
  font-size: 13px;
  font-weight: 700;
  color: #cbced4;
}

input[type="text"],
input[type="number"],
input[type="email"] {
  width: 100%;
  height: 40px;
  border: none;
  outline: 0;
  border-radius: 5px;
  border: 1px solid #cbced4;
  gap: 20px;
  box-sizing: border-box;
  padding: 0px 10px;
}
select {
  width: 100%;
  height: 40px;
  border: none;
  outline: 0;
  border-radius: 5px;
  border: 1px solid #cbced4;
  gap: 20px;
  box-sizing: border-box;
  padding: 0px 10px;
}
.input-text .input-div span {
  position: absolute;
  top: 10px;
  left: 22px;
  font-size: 14px;
  transition: all 0.5s;
}
.input-div input:focus ~ span,
.input-div input:valid ~ span {
  top: -15px;
  left: 18px;
  font-size: 10px;
  font-weight: 600;
}
/* .buttons button {
  height: 40px;
  width: 100px;
  border: none;
  border-radius: 5px;
  background-color: #0075ff;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
} */
.button_space {
  display: flex;
  gap: 20px;
}
.button_space button:nth-child(1) {
  background-color: #fff;
  color: #000;
  border: 1px solid#000;
}
@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes scale {
  0%,
  100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}
@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 30px #7ac142;
  }
}

.warning {
  border: 1px solid red !important;
}
</style>
<template>
  <div class="m-0">
    <div class="container-fluid p-0 d-flex mt-4">
      <div class="col-lg-5 col-md-5 d-none d-md-block">
        <img
          :src="image"
          style="width: 100%; height: 100%; border-radius: 5px"
        />
      </div>
      <div class="col-lg-7 col-md-7">
        <div class="card shadow-md container-fluid m-0">
          <div class="formulaire">
            <div class="right-side pb-3">
              <div class="d-none d-md-block">
                <div style="overflow-x: auto">
                  <ul class="progress_bar d-flex">
                    <li
                      class=""
                      v-for="i in nb"
                      :key="i"
                      :class="formnumber >= i - 1 ? 'active' : ''"
                    >
                      {{ i }}
                    </li>
                  </ul>
                </div>
              </div>
              <div
                class="main"
                v-for="i in nb"
                :key="i"
                :class="formnumber >= i - 1 ? 'active' : ''"
              >
                <div class="text">
                  <h2 class="d-none d-md-block titre">
                    <!-- {{ i }}. Your Personal Information -->
                  </h2>
                  <h4 class="d-block d-md-none">
                    {{ i }}/{{ nb }} Personal Information
                  </h4>
                  <p>
                    Enter your personal information to get closer to copanies.
                  </p>
                </div>
                <div class="input-text row">
                  <FirstInput
                    title="Text champ"
                    type="text"
                    class="col-lg-6 mb-4 champ"
                    name="First name"
                  />
                  <FirstInput
                    title="Text champ"
                    type="text"
                    class="col-lg-6 mb-4 champ"
                    name="Last name"
                  />
                  <FirstInput
                    title="Email champ"
                    type="email"
                    class="col-lg-12 mb-4"
                    name="email"
                  />
                  <FirstInput
                    title="Phone"
                    type="number"
                    class="col-lg-6 mb-4 champ"
                    name="phone"
                  />
                  <div class="input-div col-lg-6 mb-4">
                    <div style="border: 1px solid #cbced4" class="rounded">
                      <select class="form-control">
                        <option>Select</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                      </select>
                    </div>
                  </div>
                  <div class="input-div col-lg-6 mb-4">
                    <p class="m-0">Textarea</p>
                    <textarea
                      name=""
                      id=""
                      require
                      required
                      style="border: none; outline: none; border: 1px solid red"
                    ></textarea>
                  </div>
                  <div class="input-div col-lg-6 mb-4">
                    <p class="m-0">Textarea</p>
                    <textarea
                      name=""
                      id=""
                      require
                      required
                      style="border: none; outline: none; border: 1px solid red"
                    ></textarea>
                  </div>
                  <div class="input-div col-lg-6 mb-4">
                    <select>
                      <option>Select</option>
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                      <option>4</option>
                      <option>5</option>
                      <option>6</option>
                      <option>7</option>
                      <option>8</option>
                      <option>9</option>
                    </select>
                  </div>
                </div>
                <div class="buttons d-flex">
                  <button
                    class="back_button mr-4 btn btn-outline-secondary"
                    :style="i > 1 ? 'display: block' : 'display: none'"
                  >
                    Back
                  </button>
                  <button
                    class="next_button btn"
                    :style="
                      i == nb
                        ? 'display: none'
                        : 'display: block; background-color: #F6BC2D; color: white; font-weight: bold'
                    "
                  >
                    Next Step
                  </button>
                  <button
                    class="btn"
                    :style="
                      i == nb
                        ? 'display: block; background-color: #F6BC2D; color: white; font-weight: bold'
                        : 'display: none'
                    "
                  >
                    Valider
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sign from "../../../../../assets/img/2.jpg";
import FirstInput from "./components/FirstInput.vue";
export default {
  components: {
    FirstInput,
  },
  data() {
    return {
      image: sign,
      name: "TextArea",
      next_click: [],
      main_form: [],
      step_list: [],
      num: [],
      formnumber: 0,
      validate_inputs: [],
      nb: 5,
      tab: [],
    };
  },
  mounted() {
    this.next_click = document.querySelectorAll(".next_button");
    this.main_form = document.querySelectorAll(".main");
    this.step_list = document.querySelectorAll(".progress_bar li");
    this.num = document.querySelector(".step-number");
    this.validate_inputs = [
      ...document.querySelectorAll(".main.active input"),
      ...document.querySelectorAll(".main.active textarea"),
    ];
    this.tab = ["un", "deux", "trois"];

    this.next_click.forEach((next_click_form) => {
      next_click_form.addEventListener("click", this.onNext);
    });
    var back_click = document.querySelectorAll(".back_button");
    back_click.forEach((back_click_form) => {
      back_click_form.addEventListener("click", this.onBack);
    });
  },
  methods: {
    onNext() {
      if (!this.validateform()) {
        return false;
      }
      this.formnumber++;
      this.updateform();
      this.progress_forward();
    },
    onBack() {
      this.formnumber--;
      this.updateform();
      this.progress_backward();
    },
    updateform() {
      this.main_form.forEach(function (mainform_number) {
        mainform_number.classList.remove("active");
      });
      this.main_form[this.formnumber].classList.add("active");
      document.querySelectorAll(".titre").innerHTML(this.tab[this.formnumber]);
      console.log("Test" + this.tab[this.formnumber]);
    },
    progress_forward() {
      this.num.innerHTML = this.formnumber + 1;
      this.step_list[this.formnumber].classList.add("active");
    },
    progress_backward() {
      var form_num = this.formnumber + 1;
      this.step_list[form_num].classList.remove("active");
      this.num.innerHTML = form_num;
    },
    validateform() {
      let validate = true;
      this.validate_inputs.forEach(function (vaildate_input) {
        vaildate_input.classList?.remove("warning");
        if (vaildate_input.hasAttribute("require")) {
          if (vaildate_input.value.length == 0) {
            validate = false;
            vaildate_input.classList?.add("warning");
          }
        }
      });
      return validate;
    },
  },
};
</script>
